// authProvider.js
import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import { MsalConfig } from './config';

// https://www.npmjs.com/package/react-aad-msal

// Msal Configurations
const msalConfig = ({ azureTenantId, applicationId }: MsalConfig) => ({
    auth: {
        authority: 'https://login.microsoftonline.com/' + azureTenantId,
        clientId: applicationId || '',
        redirectUri: window.location.origin, //'https://hybridbotservicetbolsh.azurewebsites.net/static/covid_bot/'
    },
    cache: {
        cacheLocation: 'sessionStorage' as const,
        storeAuthStateInCookie: false,
    },
});

// Authentication Parameters
const authenticationParameters = {
    scopes: ['openid', 'profile', 'User.Read'],
};

// Options
const options = {
    loginType: LoginType.Popup,
    tokenRefreshUri: window.location.origin + '/auth.html',
};

export const getAuthProvider = (msalConfigVals: MsalConfig | undefined) => {
    if (!msalConfigVals) {
        console.error('msalConfig not defined');
        return null;
    }
    return new MsalAuthProvider(
        msalConfig(msalConfigVals),
        authenticationParameters,
        options
    );
};
